import React, { useState } from "react";
import {
  X,
  Users,
  Briefcase,
  Send,
  Upload,
  Linkedin,
  Github,

  CheckCircle,
} from "lucide-react";
import { useDarkMode } from "../../context/DarkModeContext";
import { useLanguage } from "../../context/LanguageContext";
const ColaborarModal = () => {
  const { isDarkMode } = useDarkMode();
  const [isOpen, setIsOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    type: "colaborar",
    area: "",
    linkedin: "",
    github: "",
    portfolio: "",
    message: "",
    cv: null,
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const { language, t, translations } = useLanguage();
  const colaborar = translations[language].colaborar;
  const handleSubmit = (e) => {
    e.preventDefault();
    // Aquí iría la lógica de envío
    console.log("Formulario enviado:", formData);
    setIsSubmitted(true);
    setTimeout(() => {
      setIsSubmitted(false);
      setIsOpen(false);
      // Reset form
      setFormData({
        name: "",
        email: "",
        phone: "",
        type: "colaborar",
        area: "",
        linkedin: "",
        github: "",
        portfolio: "",
        message: "",
        cv: null,
      });
    }, 3000);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  return (
    <>
      <div className="mt-6 p-4 bg-gray-800 rounded-lg">
        <p className="text-sm text-gray-300 mb-2">
          {colaborar.textos.quieresFormarParte}
        </p>
        <button
          onClick={() => setIsOpen(true)}
          className="w-full px-4 py-2 bg-gradient-to-r from-[#12A9B0] to-[#0e8d92] text-white rounded-lg font-medium hover:shadow-lg transition-all duration-300 hover:scale-105 flex items-center justify-center gap-2"
        >
          {colaborar.botones.colaboraConNosotros}
          <Users size={16} />
        </button>
      </div>

      {isOpen && (
        <>
          <div
            className="fixed inset-0 bg-black/50 z-[9997] transition-opacity duration-300"
            onClick={() => setIsOpen(false)}
          />
          <div className="fixed inset-0 z-[9998] overflow-y-auto">
            <div className="flex items-center justify-center min-h-screen p-4">
              <div className="relative w-full max-w-2xl rounded-2xl shadow-2xl transform transition-all bg-white dark:bg-gray-900">
                <div className="sticky top-0 z-10 px-6 py-4 border-b bg-white border-gray-200 dark:bg-gray-900 dark:border-gray-700 rounded-t-2xl">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <div className="p-2 bg-[#12A9B0]/10 rounded-lg">
                        <Users className="text-[#12A9B0]" size={24} />
                      </div>
                      <div>
                        <h2 className="text-xl font-bold text-gray-900 dark:text-white">
                          {colaborar.textos.uneAHeuristiko}
                        </h2>
                        <p className="text-sm text-gray-600 dark:text-gray-400">
                          {colaborar.textos.colaboraTrabaja}
                        </p>
                      </div>
                    </div>
                    <button
                      onClick={() => setIsOpen(false)}
                      className="p-2 rounded-lg transition-colors hover:bg-gray-100 dark:hover:bg-gray-800"
                    >
                      <X size={20} />
                    </button>
                  </div>
                </div>

                <div className="px-6 py-4 max-h-[70vh] overflow-y-auto">
                  {!isSubmitted ? (
                    <div className="space-y-6">
                      <div className="flex gap-4">
                        <label
                          className={`flex-1 p-4 rounded-lg border-2 cursor-pointer transition-all ${
                            formData.type === "colaborar"
                              ? "border-[#12A9B0] bg-[#12A9B0]/5"
                              : isDarkMode
                              ? "border-gray-700"
                              : "border-gray-200"
                          }`}
                        >
                          <input
                            type="radio"
                            name="type"
                            value="colaborar"
                            checked={formData.type === "colaborar"}
                            onChange={handleInputChange}
                            className="sr-only"
                          />
                          <div className="text-center">
                            <Briefcase
                              className={`mx-auto mb-2 ${
                                formData.type === "colaborar"
                                  ? "text-[#12A9B0]"
                                  : "text-gray-400"
                              }`}
                              size={24}
                            />
                            <p className="font-medium text-gray-900  dark:text-white">
                              {colaborar.textos.colaborar}
                            </p>
                            <p className="text-xs mt-1 text-gray-600 dark:text-gray-400">
                              {colaborar.textos.proyectosPartnerships}
                            </p>
                          </div>
                        </label>

                        <label
                          className={`flex-1 p-4 rounded-lg border-2 cursor-pointer transition-all ${
                            formData.type === "trabajar"
                              ? "border-[#12A9B0] bg-[#12A9B0]/5"
                              : isDarkMode
                              ? "border-gray-700"
                              : "border-gray-200"
                          }`}
                        >
                          <input
                            type="radio"
                            name="type"
                            value="trabajar"
                            checked={formData.type === "trabajar"}
                            onChange={handleInputChange}
                            className="sr-only"
                          />
                          <div className="text-center">
                            <Users
                              className={`mx-auto mb-2 ${
                                formData.type === "trabajar"
                                  ? "text-[#12A9B0]"
                                  : "text-gray-400"
                              }`}
                              size={24}
                            />
                            <p className="font-medium text-gray-900 dark:text-white">
                              {colaborar.textos.trabajar}
                            </p>
                            <p className="text-xs mt-1 text-gray-600 dark:text-gray-400">
                              {colaborar.textos.uneAlEquipo}
                            </p>
                          </div>
                        </label>
                      </div>

                      <div className="grid md:grid-cols-2 gap-4">
                        <div>
                          <label className="block text-sm font-medium mb-1 text-gray-700 dark:text-gray-300">
                            {colaborar.formulario.campos.nombre.label}
                          </label>
                          <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleInputChange}
                            required
                            className="w-full px-4 py-2 rounded-lg border bg-white border-gray-300 dark:bg-gray-800 dark:border-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#12A9B0]"
                          />
                        </div>

                        <div>
                          <label className="block text-sm font-medium mb-1 text-gray-700 dark:text-gray-300">
                            {colaborar.formulario.campos.email.label}
                          </label>
                          <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                            required
                            className="w-full px-4 py-2 rounded-lg border bg-white border-gray-300 dark:bg-gray-800 dark:border-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#12A9B0]"
                          />
                        </div>
                      </div>

                      <div>
                        <label className="block text-sm font-medium mb-1 text-gray-700 dark:text-gray-300">
                          {formData.type === "trabajar"
                            ? colaborar.formulario.campos.area.labelTrabajar
                            : colaborar.formulario.campos.area.labelColaborar}
                        </label>
                        <select
                          name="area"
                          value={formData.area}
                          onChange={handleInputChange}
                          required
                          className="w-full px-4 py-2 rounded-lg border bg-white border-gray-300 dark:bg-gray-800 dark:border-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#12A9B0]"
                        >
                          <option value="">
                            {
                              colaborar.formulario.campos.area.opciones
                                .selecciona
                            }
                          </option>
                          <option value="frontend">
                            {colaborar.formulario.campos.area.opciones.frontend}
                          </option>
                          <option value="backend">
                            {colaborar.formulario.campos.area.opciones.backend}
                          </option>
                          <option value="fullstack">
                            {
                              colaborar.formulario.campos.area.opciones
                                .fullstack
                            }
                          </option>
                          <option value="mobile">
                            {colaborar.formulario.campos.area.opciones.mobile}
                          </option>
                          <option value="devops">
                            {colaborar.formulario.campos.area.opciones.devops}
                          </option>
                          <option value="ia">
                            {colaborar.formulario.campos.area.opciones.ia}
                          </option>
                          <option value="ui-ux">
                            {colaborar.formulario.campos.area.opciones.uiUx}
                          </option>
                          <option value="marketing">
                            {
                              colaborar.formulario.campos.area.opciones
                                .marketing
                            }
                          </option>
                          <option value="ventas">
                            {colaborar.formulario.campos.area.opciones.ventas}
                          </option>
                          <option value="otro">
                            {colaborar.formulario.campos.area.opciones.otro}
                          </option>
                        </select>
                      </div>

                      {formData.type === "trabajar" && (
                        <div className="space-y-4">
                          <div>
                            <label className="block text-sm font-medium mb-1 text-gray-700 dark:text-gray-300">
                              <Linkedin size={16} className="inline mr-2" />
                              {colaborar.formulario.campos.linkedin.label}
                            </label>
                            <input
                              type="url"
                              name="linkedin"
                              value={formData.linkedin}
                              onChange={handleInputChange}
                              placeholder={
                                colaborar.formulario.campos.linkedin.placeholder
                              }
                              className="w-full px-4 py-2 rounded-lg border  bg-white border-gray-300 dark:bg-gray-800 dark:border-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#12A9B0]"
                            />
                          </div>

                          <div>
                            <label className="block text-sm font-medium mb-1 text-gray-700 dark:text-gray-300">
                              <Github size={16} className="inline mr-2" />
                              {colaborar.formulario.campos.github.label}
                            </label>
                            <input
                              type="url"
                              name="github"
                              value={formData.github}
                              onChange={handleInputChange}
                              placeholder={
                                colaborar.formulario.campos.github.placeholder
                              }
                              className="w-full px-4 py-2 rounded-lg border bg-white border-gray-300 dark:bg-gray-800 dark:border-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#12A9B0]"
                            />
                          </div>
                        </div>
                      )}

                      <div>
                        <label className="block text-sm font-medium mb-1 text-gray-700 dark:text-gray-300">
                          {formData.type === "trabajar"
                            ? colaborar.formulario.campos.mensaje.labelTrabajar
                            : colaborar.formulario.campos.mensaje
                                .labelColaborar}
                        </label>
                        <textarea
                          name="message"
                          value={formData.message}
                          onChange={handleInputChange}
                          required
                          rows="4"
                          className="w-full px-4 py-2 rounded-lg border bg-white border-gray-300 dark:bg-gray-800 dark:border-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#12A9B0]"
                        />
                      </div>

                      {formData.type === "trabajar" && (
                        <div>
                          <label className="block text-sm font-medium mb-1 text-gray-700 dark:text-gray-300">
                            <Upload size={16} className="inline mr-2" />
                            {colaborar.formulario.campos.cv.label}
                          </label>
                          <input
                            type="file"
                            accept=".pdf"
                            onChange={(e) =>
                              setFormData((prev) => ({
                                ...prev,
                                cv: e.target.files[0],
                              }))
                            }
                            className="w-full px-4 py-2 rounded-lg border bg-white border-gray-300 dark:bg-gray-800 dark:border-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#12A9B0]"
                          />
                        </div>
                      )}

                      <div className="flex gap-4 pt-4">
                        <button
                          type="button"
                          onClick={() => setIsOpen(false)}
                          className="flex-1 px-6 py-3 rounded-lg font-medium transition-all bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700"
                        >
                          {colaborar.botones.cancelar}
                        </button>
                        <button
                          onClick={handleSubmit}
                          className="flex-1 px-6 py-3 bg-gradient-to-r from-[#12A9B0] to-[#0e8d92] text-white rounded-lg font-medium hover:shadow-lg transition-all duration-300 flex items-center justify-center gap-2"
                        >
                          {colaborar.botones.enviar}
                          <Send size={18} />
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="py-12 text-center">
                      <CheckCircle
                        className="mx-auto text-green-500 mb-4"
                        size={64}
                      />
                      <h3 className="text-xl font-bold mb-2 text-gray-900 dark:text-white">
                        {colaborar.textos.mensajeExito}
                      </h3>
                      <p className="text-gray-600 dark:text-gray-400">
                        {colaborar.textos.contactoPronto}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
  /*   return (
    <>
      <div className="mt-6 p-4 bg-gray-800 rounded-lg">
        <p className="text-sm text-gray-300 mb-2">¿Quieres formar parte?</p>
        <button
          onClick={() => setIsOpen(true)}
          className="w-full px-4 py-2 bg-gradient-to-r from-[#12A9B0] to-[#0e8d92] text-white rounded-lg font-medium hover:shadow-lg transition-all duration-300 hover:scale-105 flex items-center justify-center gap-2"
        >
          Colabora con nosotros
          <Users size={16} />
        </button>
      </div>

      {isOpen && (
        <>
          <div
            className="fixed inset-0 bg-black/50 z-[9997] transition-opacity duration-300"
            onClick={() => setIsOpen(false)}
          />
          <div className="fixed inset-0 z-[9998] overflow-y-auto">
            <div className="flex items-center justify-center min-h-screen p-4">
              <div className="relative w-full max-w-2xl rounded-2xl shadow-2xl transform transition-all bg-white dark:bg-gray-900">
                <div className="sticky top-0 z-10 px-6 py-4 border-b bg-white border-gray-200 dark:bg-gray-900 dark:border-gray-700 rounded-t-2xl">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <div className="p-2 bg-[#12A9B0]/10 rounded-lg">
                        <Users className="text-[#12A9B0]" size={24} />
                      </div>
                      <div>
                        <h2 className="text-xl font-bold text-gray-900 dark:text-white">
                          Únete a Heuristiko
                        </h2>
                        <p className="text-sm text-gray-600 dark:text-gray-400">
                          Colabora o trabaja con nosotros
                        </p>
                      </div>
                    </div>
                    <button
                      onClick={() => setIsOpen(false)}
                      className="p-2 rounded-lg transition-colors hover:bg-gray-100 dark:hover:bg-gray-800"
                    >
                      <X size={20} />
                    </button>
                  </div>
                </div>

                <div className="px-6 py-4 max-h-[70vh] overflow-y-auto">
                  {!isSubmitted ? (
                    <div className="space-y-6">
                      <div className="flex gap-4">
                        <label
                          className={`flex-1 p-4 rounded-lg border-2 cursor-pointer transition-all ${
                            formData.type === "colaborar"
                              ? "border-[#12A9B0] bg-[#12A9B0]/5"
                              : isDarkMode
                              ? "border-gray-700"
                              : "border-gray-200"
                          }`}
                        >
                          <input
                            type="radio"
                            name="type"
                            value="colaborar"
                            checked={formData.type === "colaborar"}
                            onChange={handleInputChange}
                            className="sr-only"
                          />
                          <div className="text-center">
                            <Briefcase
                              className={`mx-auto mb-2 ${
                                formData.type === "colaborar"
                                  ? "text-[#12A9B0]"
                                  : "text-gray-400"
                              }`}
                              size={24}
                            />
                            <p className="font-medium text-gray-900  dark:text-white">
                              Colaborar
                            </p>
                            <p className="text-xs mt-1 text-gray-600 dark:text-gray-400">
                              Proyectos y partnerships
                            </p>
                          </div>
                        </label>

                        <label
                          className={`flex-1 p-4 rounded-lg border-2 cursor-pointer transition-all ${
                            formData.type === "trabajar"
                              ? "border-[#12A9B0] bg-[#12A9B0]/5"
                              : isDarkMode
                              ? "border-gray-700"
                              : "border-gray-200"
                          }`}
                        >
                          <input
                            type="radio"
                            name="type"
                            value="trabajar"
                            checked={formData.type === "trabajar"}
                            onChange={handleInputChange}
                            className="sr-only"
                          />
                          <div className="text-center">
                            <Users
                              className={`mx-auto mb-2 ${
                                formData.type === "trabajar"
                                  ? "text-[#12A9B0]"
                                  : "text-gray-400"
                              }`}
                              size={24}
                            />
                            <p className="font-medium text-gray-900 dark:text-white">
                              Trabajar
                            </p>
                            <p className="text-xs mt-1 text-gray-600 dark:text-gray-400">
                              Únete al equipo
                            </p>
                          </div>
                        </label>
                      </div>

                      <div className="grid md:grid-cols-2 gap-4">
                        <div>
                          <label className="block text-sm font-medium mb-1 text-gray-700 dark:text-gray-300">
                            Nombre completo *
                          </label>
                          <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleInputChange}
                            required
                            className="w-full px-4 py-2 rounded-lg border bg-white border-gray-300 dark:bg-gray-800 dark:border-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#12A9B0]"
                          />
                        </div>

                        <div>
                          <label className="block text-sm font-medium mb-1 text-gray-700 dark:text-gray-300">
                            Email *
                          </label>
                          <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                            required
                            className="w-full px-4 py-2 rounded-lg border bg-white border-gray-300 dark:bg-gray-800 dark:border-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#12A9B0]"
                          />
                        </div>
                      </div>

                      <div>
                        <label className="block text-sm font-medium mb-1 text-gray-700 dark:text-gray-300">
                          {formData.type === "trabajar"
                            ? "Área de especialización *"
                            : "Área de colaboración *"}
                        </label>
                        <select
                          name="area"
                          value={formData.area}
                          onChange={handleInputChange}
                          required
                          className="w-full px-4 py-2 rounded-lg border bg-white border-gray-300 dark:bg-gray-800 dark:border-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#12A9B0]"
                        >
                          <option value="">Selecciona una opción</option>
                          <option value="frontend">Desarrollo Frontend</option>
                          <option value="backend">Desarrollo Backend</option>
                          <option value="fullstack">Full Stack</option>
                          <option value="mobile">Desarrollo Móvil</option>
                          <option value="devops">DevOps</option>
                          <option value="ia">Inteligencia Artificial</option>
                          <option value="ui-ux">UI/UX Design</option>
                          <option value="marketing">Marketing Digital</option>
                          <option value="ventas">Ventas</option>
                          <option value="otro">Otro</option>
                        </select>
                      </div>

                      {formData.type === "trabajar" && (
                        <div className="space-y-4">
                          <div>
                            <label className="block text-sm font-medium mb-1 text-gray-700 dark:text-gray-300">
                              <Linkedin size={16} className="inline mr-2" />
                              LinkedIn
                            </label>
                            <input
                              type="url"
                              name="linkedin"
                              value={formData.linkedin}
                              onChange={handleInputChange}
                              placeholder="https://linkedin.com/in/tu-perfil"
                              className="w-full px-4 py-2 rounded-lg border  bg-white border-gray-300 dark:bg-gray-800 dark:border-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#12A9B0]"
                            />
                          </div>

                          <div>
                            <label className="block text-sm font-medium mb-1 text-gray-700dark:text-gray-300">
                              <Github size={16} className="inline mr-2" />
                              GitHub
                            </label>
                            <input
                              type="url"
                              name="github"
                              value={formData.github}
                              onChange={handleInputChange}
                              placeholder="https://github.com/tu-usuario"
                              className="w-full px-4 py-2 rounded-lg border bg-white border-gray-300 dark:bg-gray-800 dark:border-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#12A9B0]"
                            />
                          </div>
                        </div>
                      )}

                      <div>
                        <label className="block text-sm font-medium mb-1 text-gray-700 dark:text-gray-300">
                          {formData.type === "trabajar"
                            ? "Cuéntanos sobre ti"
                            : "Describe tu propuesta"}{" "}
                          *
                        </label>
                        <textarea
                          name="message"
                          value={formData.message}
                          onChange={handleInputChange}
                          required
                          rows="4"
                          className="w-full px-4 py-2 rounded-lg border bg-white border-gray-300 dark:bg-gray-800 dark:border-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#12A9B0]"
                        />
                      </div>

                      {formData.type === "trabajar" && (
                        <div>
                          <label className="block text-sm font-medium mb-1 text-gray-700 dark:text-gray-300">
                            <Upload size={16} className="inline mr-2" />
                            CV / Portfolio (PDF, máx. 5MB)
                          </label>
                          <input
                            type="file"
                            accept=".pdf"
                            onChange={(e) =>
                              setFormData((prev) => ({
                                ...prev,
                                cv: e.target.files[0],
                              }))
                            }
                            className="w-full px-4 py-2 rounded-lg border bg-white border-gray-300 dark:bg-gray-800 dark:border-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#12A9B0]"
                          />
                        </div>
                      )}

 
                      <div className="flex gap-4 pt-4">
                        <button
                          type="button"
                          onClick={() => setIsOpen(false)}
                          className="flex-1 px-6 py-3 rounded-lg font-medium transition-all bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700"
                        >
                          Cancelar
                        </button>
                        <button
                          onClick={handleSubmit}
                          className="flex-1 px-6 py-3 bg-gradient-to-r from-[#12A9B0] to-[#0e8d92] text-white rounded-lg font-medium hover:shadow-lg transition-all duration-300 flex items-center justify-center gap-2"
                        >
                          Enviar
                          <Send size={18} />
                        </button>
                      </div>
                    </div>
                  ) : (
                    // Success message
                    <div className="py-12 text-center">
                      <CheckCircle
                        className="mx-auto text-green-500 mb-4"
                        size={64}
                      />
                      <h3 className="text-xl font-bold mb-2 text-gray-900 dark:text-white">
                        ¡Mensaje enviado con éxito!
                      </h3>
                      <p className="text-gray-600 dark:text-gray-400">
                        Nos pondremos en contacto contigo pronto.
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  ); */
};

export default ColaborarModal;
